<template>
  <div class="body">
    <div v-if="hasList" class="abort-selling">
      <primary-button @onClick="goToListingPage">
        List
      </primary-button>
    </div>
    <div v-if="hasCancelListing" class="abort-selling">
      <secondary-button
        :is-disable="isCanceling"
        @onClick="$bvModal.show('abort-selling-modal')"
      >
        <template v-if="isCanceling">
          <b-icon icon="arrow-clockwise" animation="spin" font-scale="1.5" />
        </template>
        <template v-else>
          Cancel Listing
        </template>
      </secondary-button>
    </div>
    <div v-if="!isEmpty(metadata)" class="artwork-information">
      <img class="back" src="@/assets/icon/back.svg" @click="$router.back()" />

      <div class="artwork-overview">
        <div class="artwork-image">
          <!--          <LikeButton class="like-button" :isLiked="false" />-->
          <img v-if="metadata.image" :src="metadata.image" />
        </div>
        <div class="info-board">
          <div class="info-title">
            <div>Item name</div>
            <div>Owner</div>
            <div>ID</div>
            <div>Collection</div>
          </div>
          <div class="info">
            <div>{{ metadata.name }}</div>
            <div>
              {{ ownerAddressData | blockchainAddress }}
            </div>
            <div class="info-redirect">
              {{ nftId }}
            </div>
            <div class="info-redirect">
              {{ collection }}
            </div>
          </div>
        </div>
      </div>

      <div class="artwork-collapse">
        <CustomCollapse
          v-if="isShowSellingMethod"
          class="custom-collapse"
          :collapse-id="'selling-method-collapse'"
          :collapse-header="
            `Selling Method: ${getSellMethod(sellData.sellMethod)}`
          "
        >
          <div class="description">
            {{ timestampDescription }}
          </div>
          <FixedPrice
            ref="fixedPrice"
            :nft="nft"
            :seller-address="sellerAddress"
            :market-contract="ownerAddress"
            :is-buyable="isBuyable"
            @handleRefreshData="handleRefreshData"
          />
        </CustomCollapse>
        <CustomCollapse
          class="custom-collapse"
          :collapse-id="'properties-collapse'"
          :collapse-header="'Properties'"
        >
          <div class="property-wrapper">
            <PropertyCard
              v-for="(att, index) in metadata.attributes"
              :key="index"
              :property-title="transformTraitType(att.trait_type)"
              :property-spec="getAttributeValue(att)"
            />
          </div>
        </CustomCollapse>
        <CustomCollapse
          class="custom-collapse"
          :collapse-id="'description-collapse'"
          :collapse-header="'Description'"
        >
          <div class="artwork-description">
            {{ metadata.description }}
          </div>
        </CustomCollapse>
        <CustomCollapse
          class="custom-collapse trading-history"
          :collapse-id="'trading-history-collapse'"
          :collapse-header="'Trading History'"
        >
          <TradingTable :nft-contract="nftContract" :nft-id="sellData.nftId" />
        </CustomCollapse>
        <CustomCollapse
          v-if="sellData.isEnableOffering"
          class="custom-collapse trading-history"
          :collapse-id="'offers-collapse'"
          :collapse-header="'Offers'"
        >
          <offer-table
            ref="offersTable"
            :seller-address="sellerAddress"
            :nft="nft"
            :market-contract="ownerAddress"
            @onAccept="$bvModal.show('confirm-acception-modal')"
          />
        </CustomCollapse>
      </div>
    </div>
    <item-same-collection :nft-contract="nftContract" :nft-id="nftId" />
    <base-modal
      :id="'abort-selling-modal'"
      @closeModal="$bvModal.hide('abort-selling-modal')"
    >
      <abort-selling-modal
        @onConfirm="cancelListing"
        @closeModal="$bvModal.hide('abort-selling-modal')"
      />
    </base-modal>
  </div>
</template>

<script>
// import LikeButton from '@/components/BaseComponents/LikeButton.vue';
import CustomCollapse from '@/components/BaseComponents/CustomCollapse.vue';
import PropertyCard from '@/components/BaseComponents/PropertyCard.vue';
import FixedPrice from '@/components/Marketplace/ArtworkDetail/FixedPrice.vue';
import TradingTable from '@/components/Marketplace/ArtworkDetail/TradingTable.vue';
import SecondaryButton from '@/components/BaseComponents/SecondaryButton.vue';
import AbortSellingModal from '@/modal/AbortSellingModal.vue';
import BaseModal from '@/components/BaseModal.vue';
// import PurchaseModal from '@/modal/PurchaseModal.vue';
import rf from '@/requests/RequestFactory';
import { getDutchAuctionTimestamp, getMetadataFromURIs } from '@/helpers/utils';
import provider from '@/helpers/provider';
import abi from '../../../abi';
import { Contract } from '@ethersproject/contracts';
import _ from 'lodash';
import config from '@/config';
import PrimaryButton from '@/components/BaseComponents/PrimaryButton.vue';
import {
  cancelMarketListing,
  getSellerTimestamp,
  cancelDutchAuctionListing,
  transformTraitType
} from '@/helpers/utils';
import { handleTransactionError, sleep, getSellMethod } from '@/helpers';
import ItemSameCollection from '@/components/Marketplace/ArtworkDetail/ItemSameCollection.vue';
import OfferTable from '@/components/Marketplace/ArtworkDetail/OfferTable.vue';
import moment from 'moment';
import { MARKET_ADDRESSES } from '@/constans';

export default {
  name: 'AssetDetail',
  components: {
    // LikeButton,
    CustomCollapse,
    PropertyCard,
    FixedPrice,
    TradingTable,
    SecondaryButton,
    PrimaryButton,
    // PrimaryButton,
    AbortSellingModal,
    BaseModal,
    ItemSameCollection,
    OfferTable
    // PurchaseModal,
  },
  data() {
    return {
      metadata: {},
      sellData: {},
      sellerAddress: '',
      isOwner: false,
      ownerAddress: '',
      collection: '',
      isCanceling: false,
      timestamp: null,
      marketAddresses: MARKET_ADDRESSES,
      nft: {}
    };
  },
  computed: {
    myAddress() {
      return this.$store.state.auth.address;
    },
    timestampDescription() {
      if (
        !this.timestamp ||
        !this.timestamp.endTime ||
        !this.timestamp.startTime
      )
        return;
      if (this.timestamp.startTime * 1000 > new Date().valueOf()) {
        const startTime = moment(this.timestamp.startTime * 1000)
          .utc()
          .format('DD-MM-YYYY HH:mm:ss');
        return `Sale starts at ${startTime} (UTC)`;
      }

      const endTime = moment(this.timestamp.endTime * 1000)
        .utc()
        .format('DD-MM-YYYY HH:mm:ss');
      return `Sale ends at ${endTime} (UTC)`;
    },
    isBuyable() {
      if (
        !this.timestamp ||
        !this.timestamp.endTime ||
        !this.timestamp.startTime
      ) {
        return true;
      }
      return (
        (this.timestamp.startTime * 1000 < new Date().valueOf() &&
          new Date().valueOf() < this.timestamp.endTime * 1000) ||
        this.sellData.minPrice <= 0
      );
    },
    isDutchAuctionMarket() {
      return this.ownerAddress === this.marketAddresses.dutchAuctionMarketplace;
    },
    isSelling() {
      return (
        Object.values(this.marketAddresses).indexOf(this.ownerAddress) > -1
      );
    },
    isShowSellingMethod() {
      return (
        this.isSelling &&
        this.myAddress.toLowerCase() !== this.sellerAddress.toLowerCase()
      );
    },
    hasList() {
      return this.isOwner && !this.isSelling;
    },
    hasCancelListing() {
      return this.sellerAddress === this.myAddress && this.isSelling;
    },
    ownerAddressData() {
      return this.isSelling ? this.sellerAddress : this.ownerAddress;
    },
    nftContract() {
      return this.$route.params.nftContract;
    },
    nftId() {
      return this.$route.params.nftId;
    }
  },
  watch: {
    async myAddress() {
      await this.fetchOwnerNft();
      await this.fetchSellingData();
      await this.getTimestamp();
    },
    $route() {
      this.init();
    }
  },
  async created() {
    this.init();
  },
  methods: {
    getSellMethod,
    handleTransactionError,
    transformTraitType,
    isEmpty(data) {
      return _.isEmpty(data);
    },
    async init() {
      this.collection = this.getNFTCollection();
      await this.fetchOwnerNft();
      await this.fetchSellingData();
      await this.getTimestamp();
      await this.fetchMetaDataTokenURI();
    },
    goToListingPage() {
      this.$router.push({
        name: 'listing',
        params: {
          nftContract: this.nftContract,
          nftId: this.nftId
        }
      });
    },
    async cancelListing() {
      this.$bvModal.hide('abort-selling-modal');
      if (this.isCanceling) return;
      this.isCanceling = true;
      try {
        let tx;
        if (!this.isDutchAuctionMarket) {
          tx = await cancelMarketListing(this.nftContract, this.nftId);
        } else {
          tx = await cancelDutchAuctionListing(this.nftContract, this.nftId);
        }
        sleep(30000);
        if (tx.transactionHash) {
          this.$dialog.notify.success(
            "You've canceled listing NFT successfully!"
          );
          this.$router.push({ name: 'my-collection' });
        } else {
          this.$dialog.notify.error('An error has occurred. Please try again!');
        }
      } catch (error) {
        this.isCanceling = false;
        const message = this.handleTransactionError(error);
        this.$dialog.notify.error(message);
      }
      this.isCanceling = false;
    },
    getAttributeValue(att) {
      console.log('att', att);
      return att.trait_type === 'level' || att.trait_type === 'stars'
        ? att.value + 1
        : att.value;
    },
    async fetchOwnerNft() {
      this.ownerAddress = await new Contract(
        this.nftContract,
        abi['NFT721'],
        provider
      ).ownerOf(this.nftId);
      this.isOwner =
        this.ownerAddress.toLowerCase() === this.myAddress.toLowerCase();
    },
    getTokenURI() {
      const nftContractInstance = new Contract(
        this.nftContract,
        abi['NFT721'],
        provider
      );
      return nftContractInstance.tokenURI(this.nftId);
    },
    async getTimestamp() {
      if (this.isDutchAuctionMarket) {
        return (this.timestamp = await getDutchAuctionTimestamp(
          this.nftContract,
          this.nftId
        ));
      }
      this.timestamp = await getSellerTimestamp(this.nftContract, this.nftId);
    },
    getNFTCollection() {
      if (
        this.nftContract.toLowerCase() ===
        config.addresses.artworkNftAddress.toLowerCase()
      )
        return 'Artwork';
      return _.get(
        config.projects.bunicornGame.collections.find(
          nft =>
            nft.nftContract.toLowerCase() === this.nftContract.toLowerCase()
        ),
        'nftName',
        'N/A'
      );
    },
    async getSellerAddress() {
      if (this.ownerAddress === this.marketAddresses.dutchAuctionMarketplace) {
        const marketplaceContract = new Contract(
          this.ownerAddress,
          abi['BunicornNFTAuctionMarketplace'],
          provider
        );
        const res = await marketplaceContract.getDutchAuctionListing(
          this.nftContract,
          this.nftId
        );
        if (res) {
          this.sellerAddress = res[0];
        }
      } else {
        const marketplaceContract = new Contract(
          this.ownerAddress,
          abi['Marketplace'],
          provider
        );

        this.sellerAddress = await marketplaceContract.getSellerOfNftID(
          this.nftContract,
          this.nftId
        );
      }
    },
    async fetchSellingData() {
      if (this.isSelling) {
        await this.getSellerAddress();
        this.sellData = await rf
          .getRequest('GameMarketplaceRequest')
          .getNFT(this.nftContract, this.nftId);
        const { metaData } = this.sellData;
        this.nft = {
          name: metaData.name,
          contract: this.nftContract,
          id: this.nftId,
          isEnableOffering: this.sellData.isEnableOffering
        };
        this.metadata = {
          name: metaData.name,
          description: metaData.description,
          image: metaData.image,
          attributes: metaData.attributes
        };
      }
    },
    async fetchMetaDataTokenURI() {
      if (this.isEmpty(this.metadata)) {
        const tokenURI = await this.getTokenURI(this.nftContract, this.nftId);
        const [metadata] = await getMetadataFromURIs([tokenURI]);
        this.metadata = metadata;
      }
    },
    handleRefreshData() {
      this.init();
      this.$refs.offersTable && this.$refs.offersTable.fetchData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/config/_variables';
.body {
  margin: 40px 40px;
  .abort-selling {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 25px;
    div {
      margin: 0 8px;
    }
  }
  .artwork-information {
    position: relative;

    display: flex;
    font-family: Inter;
    .back {
      position: absolute;
      top: -30px;
      left: 0;
      cursor: pointer;
      width: 25px;
      height: 25px;
      object-fit: contain;
    }

    .artwork-overview {
      width: 242px;
      .artwork-image {
        width: 242px;
        height: 300px;
        position: relative;
        img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
        ::v-deep .slick-next:before,
        .slick-prev:before {
          content: '';
        }
        .custom-arrow {
          width: 76px;
          z-index: 1;
          transform: translate(0, -50%);
          img {
            width: 76px;
            height: 76px;
            object-fit: contain;
          }
        }
        .slick-prev {
          left: -36px;
        }
        .slick-next {
          right: -36px;
        }
        .like-button {
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: #ffffff;
          border-radius: 50%;
          padding: 8px;
          z-index: 2;
        }
      }
      .info-board {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        line-height: 24px;
        .info-title {
          color: #828c9f;
        }
        .info {
          text-align: right;
          font-weight: 500;
          color: #203a54;
          // .info-redirect {
          //   color: #00a3fe;
          // }
        }
      }
    }

    .artwork-collapse {
      margin-left: 50px;
      flex-grow: 1;
      .trading-history {
        overflow-x: auto;
      }
      .custom-collapse {
        margin-bottom: 14px;
        .description {
          color: #828c9f;
          margin-bottom: 10px;
        }
        .artwork-description {
          font-size: 16px;
        }
        .property-wrapper {
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          > div {
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: $breakpoint-desktop) {
  .body {
    margin: 40px auto;
    .artwork-information {
      flex-wrap: wrap;

      .artwork-overview {
        width: 80%;
        margin: 0 auto 30px auto;
        .artwork-image {
          margin: auto;
          img {
            object-fit: contain;
            width: 100%;
            height: 100%;
          }
        }
      }

      .artwork-collapse {
        margin-left: 0;
        width: 100%;
      }
    }
  }
}
</style>
